/**
 * Post-checkout landing. Paddle redirects here after a successful subscription (successUrl on
 * Checkout.open). It confirms the sale in plain language and points the person at what happens
 * next — provisioning is handled off this page, so this is a receipt, not a setup wizard.
 */
import { Link } from 'react-router-dom';
import './pricing.css';

export function Welcome() {
  return (
    <main className="pricing welcome">
      <span className="pricing-mark" aria-hidden="true">
        N
      </span>
      <h1>You're all set.</h1>
      <p className="pricing-sub">
        Thanks for subscribing to NightDesk. Your receipt is on its way by email. We'll reach out
        shortly to point your after-hours line at NightDesk and get your on-call ladder set up —
        usually the same business day.
      </p>
      <div className="welcome-actions">
        <Link className="tier-cta tier-cta--hi" to="/login">
          Sign in to your console
        </Link>
        <Link className="tier-cta" to="/pricing">
          Back to plans
        </Link>
      </div>
    </main>
  );
}

export default Welcome;
